module.exports = __webpack_public_path__ + "static/media/audr.09f037c3.svg";